var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('svg',{staticClass:"c-tachyon-particle-container"},_vm._l((_vm.count),function(i){return _c('TachyonParticle',{key:i,attrs:{"bounds":_vm.bounds,"is-blob":_vm.isBlob}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }